'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Navbar = require('./Navbar');

var _Navbar2 = _interopRequireDefault(_Navbar);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Main(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_Navbar2.default, props),
    _react2.default.createElement(
      'main',
      { className: 'container ' + _style2.default.main },
      props.children
    )
  );
}

var oneOfType = _propTypes2.default.oneOfType,
    arrayOf = _propTypes2.default.arrayOf,
    element = _propTypes2.default.element;

Main.propTypes = {
  children: oneOfType([arrayOf(element), element])
};

exports.default = Main;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Main/Main.js
// module id = 1022
// module chunks = 0